// extracted by mini-css-extract-plugin
module.exports = {"noDataFoundContainer":"style_noDataFoundContainer__FVXZG","noDataFound":"style_noDataFound__llE-B"};